export const A_PERSON_IS_PRESENT_FOR = 45_000;

export type SeenHere = { account: string; at: string };

export function seenAt(at: string | null | undefined): number | null {
  if (!at) return null;
  const when = new Date(at).getTime();
  return Number.isFinite(when) ? when : null;
}

export function isPresent(
  at: string | null | undefined,
  now: number,
  within: number = A_PERSON_IS_PRESENT_FOR,
): boolean {
  const when = seenAt(at);
  if (when === null) return false;
  return now - when <= within;
}

export function presentAmong(
  seen: readonly SeenHere[],
  now: number,
  within: number = A_PERSON_IS_PRESENT_FOR,
): Set<string> {
  const here = new Set<string>();
  for (const one of seen) if (isPresent(one.at, now, within)) here.add(one.account);
  return here;
}

export function sameNames(one: ReadonlySet<string>, two: ReadonlySet<string>): boolean {
  if (one.size !== two.size) return false;
  for (const name of one) if (!two.has(name)) return false;
  return true;
}
